export default "__VITE_ASSET__RZBacmvE__"